import { h, Fragment } from "preact";
import { useState, useEffect, useMemo } from "preact/hooks";
import fs from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import {
  Modal,
  Typography,
  Button,
  Select,
  Input,
  Skeleton,
  Spin,
  Image,
  Table,
} from "antd";
import {
  getTransactionTimeAtUTC,
  convertDateFormat,
  serviceMap,
} from "./TransactionsUtils";
import { LeftCircleOutlined } from "@ant-design/icons";
const TransactionHistoryPage = ({
  visible,
  onCancel,
  transactionInfo,
  setCurrentPage,
}) => {
  const [tableData, setTableData] = useState([]);

  const cols = [
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
    },
  ];

  useEffect(() => {
    const newData = [];
    transactionInfo?.session_projections?.forEach((sessionProjection) => {
      const { service_name, session_states } = sessionProjection;
      session_states.forEach((sessionState) => {
        const { state_name } = sessionState;
        const created_at = convertDateFormat(sessionState.created_at);
        newData.push({
          event: serviceMap.get(service_name),
          time: created_at,
          status: state_name,
          user: sessionProjection.person_id,
        });
      });
    });

    // const sortedData = newData.sort((a, b) => {
    //    const dateA = new Date(a.time);
    //    const dateB = new Date(b.time);

    //    return dateB - dateA; // Descending order
    //  });
    // setTableData(sortedData);
    setTableData(newData.reverse());
  }, [transactionInfo]);

  const convertToXLSX = () => {
    const data = tableData.map((item) => Object.values(item));
    data.unshift(cols.map((column) => column.title));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { type: "array", bookType: "xlsx" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    fs.saveAs(blob, "transaction_history.xlsx");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflowY: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          backgroundColor: "#F0F2F5",
          width: "100%",
          padding: "24px",
          borderRadius: "20px 20px 0px 0px",
          justifyContent: "space-between",
          alignItems: "center",
          height: "10%",
        }}
      >
        <LeftCircleOutlined
          onClick={() => setCurrentPage("main")}
          className="card-image-large-control-btns back-btn"
          style={{ cursor: "pointer", marginLeft: "16px" }}
        />
        <Typography.Title level={3} className="card-title">
          History of transactions
        </Typography.Title>
        <Button
          style={{ marginRight: "40px" }}
          disabled={tableData.length === 0}
          onClick={convertToXLSX}
          id="download-history-btn"
        >
          Download .xlsx
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          flex: 1,
          padding: "24px",
          width: "100%",
          height: "100%",
        }}
      >
        <Table
          columns={cols}
          dataSource={tableData}
          style={{ width: "100%", height: "100%" }}
          scroll={{ y: "calc(100vh - 220px)" }}
          pagination={false}
          className="transaction-history-table"
        />
      </div>
    </div>
  );
};

export default TransactionHistoryPage;
